import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { logout } from 'redux/auth/actions';

export interface RouteBranchState {
    // Default parent URL to redirect to on end if branch was not initialized
    parentURL?: string;

    // We don't have a good way of catching whether the router is
    // doing a back or forward operation, so we duplicate the route
    // history here to track changes to it.
    //
    // These are location keys instead of pathnames because we can then omit
    // duplicates caused by forward/back buttons on the browser, etc.
    locationKeyHistory?: string[];
}

const initialState: RouteBranchState = {};

const routeBranchSlice = createSlice({
    name: 'routeBranch',
    initialState,
    reducers: {
        setRouteBranchParent: (state, action: PayloadAction<string | undefined>) => {
            state.parentURL = action.payload;
        },
        resetRouteBranch: (state) => {
            state.parentURL = undefined;
            state.locationKeyHistory = undefined;
        },
        initRouteBranchHistory: (state, action: PayloadAction<string>) => {
            state.locationKeyHistory = [action.payload];
        },
        pushToRouteBranchHistory: (state, action: PayloadAction<string>) => {
            if (state.locationKeyHistory !== undefined) {
                state.locationKeyHistory?.push(action.payload);
            }
        },
    },
    extraReducers: (builder) => {
        builder.addCase(logout.fulfilled, () => {
            return initialState;
        });
    },
});

export const { setRouteBranchParent, initRouteBranchHistory, resetRouteBranch, pushToRouteBranchHistory } =
    routeBranchSlice.actions;

export default routeBranchSlice.reducer;
